import * as _ from "lodash-es";
import axios from "axios";
import { makeOptions } from "@/form-utils";
import { notifyAxiosError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";
import Vue from "vue";

// All such CRUD stores are the same (e.g. InterviewStore, FollowupStore, SystemEventsStore)
// TODO: create base store.
export default {
  namespaced: true,
  state: {
    interviewersMap: {},
    interviewCategoriesMap: {},
    isInterviewersFetching: false,
    isInterviewersFetched: false,
  },
  mutations: {
    setInterviewers: function (state, interviewers) {
      state.interviewersMap = _.keyBy(interviewers, "id");
    },
    setInterviewCategories: function (state, interviewCategories) {
      state.interviewCategoriesMap = _.keyBy(interviewCategories, "id");
    },
    setInterviewersFetching: function (state, isInterviewersFetching) {
      state.isInterviewersFetching = isInterviewersFetching;
    },
    setInterviewersFetched: function (state, isInterviewersFetched) {
      state.isInterviewersFetched = isInterviewersFetched;
    },
    updateInterviewer: function (state, interviewer) {
      state.interviewersMap = {
        ...state.interviewersMap,
        [interviewer.id]: interviewer,
      };
    },
    deleteInterviewer(state, id) {
      Vue.delete(state.interviewersMap, id);
    },
  },
  getters: {
    interviewersList(state) {
      return _.sortBy(Object.values(state.interviewersMap), "name");
    },
    interviewCategoriesList(state) {
      return _.sortBy(Object.values(state.interviewCategoriesMap), "name");
    },
    interviewersOptions(state, getters) {
      return makeOptions(
        getters.interviewersList.map((t) => ({ value: t.id, text: t.name })),
      );
    },
    interviewersFilterOptions(state, getters) {
      return makeOptions([
        { text: "---Unassigned---", value: "None" },
        ...getters.interviewersList.map((t) => ({ value: t.id, text: t.name })),
      ]);
    },
  },
  actions: {
    fetchInterviewers(context) {
      if (context.state.isInterviewersFetching || context.state.isInterviewersFetched) {
        return;
      }
      context.commit("setInterviewersFetching", true);
      return axios
        .get("/interview/interviewers/", {
          params: { page_size: MAX_PAGE_SIZE },
        })
        .then(
          (response) => {
            context.commit("setInterviewersFetching", false);
            context.commit("setInterviewersFetched", true);
            context.commit("setInterviewers", response.data.results);
          },
          (error) => {
            context.commit("setInterviewersFetching", false);
            notifyAxiosError(error);
          },
        );
    },
  },
};
